import { render, staticRenderFns } from "./TextMessageForm.vue?vue&type=template&id=0d85c693&"
import script from "./TextMessageForm.vue?vue&type=script&lang=js&"
export * from "./TextMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports